import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import PmaEditor from "./PMAEditor";
import axios from "common/interceptors";
import {
  startPrintFontGate,
  stopPrintFontGate,
  signalPrintReadyIfIdle,
} from "common/utils/pmaPrintReady";

// Wrapper component to use useParams hook
const PrintTableQuadrantsPMAWrapper = (props) => {
  const params = useParams();
  return <PrintTableQuadrantsPMA {...props} params={params} />;
};

class PrintTableQuadrantsPMA extends React.Component {
  state = {
    singleHOData: null,
    agentData: null,
    mlsAreas: null,
    marketActivity: null,
    MQCityDetails: null,
    currentArea: null,
    localSellingAgents: null,
    version: "table-quadrants",
    coverPageDetails: null,
    quarterlyAreaTable: null,
    testimonials: null,
    agentDesignations: null,
    agentAdvantages: null,
    salePriceForCities: null,
    yearEnd: null,
    qArea: null,
    qCity: null,
    missionStatement: null,
    aprilData: null,
    flipBook: false,
    quadrantDetails: null,
    fontsReady: false,
    fontsTimedOut: false,
  };

  async componentDidMount() {
    startPrintFontGate(this);
    // Get parameters from URL or props
    let mailProId, listgenUserID, brokerage;
    
    if (this.props.params) {
      mailProId = this.props.params.mailproid;
      listgenUserID = this.props.params.listgenUserID;
      brokerage = this.props.params.brokerage;
    } else if (this.props.match && this.props.match.params) {
      mailProId = this.props.match.params.mailproid;
      listgenUserID = this.props.match.params.listgenUserID;
      brokerage = this.props.match.params.brokerage;
    } else {
      // Fallback: extract from URL
      const urlParams = new URLSearchParams(window.location.search);
      mailProId = urlParams.get('mailproid') || this.props.mailproid;
      listgenUserID = urlParams.get('listgenUserID') || this.props.listgenUserID;
      brokerage = urlParams.get('brokerage') || this.props.brokerage;
    }
    
    // Validate required parameters
    if (!mailProId || !listgenUserID) {
      console.error('Missing required parameters: mailProId or listgenUserID');
      return;
    }

    const { version } = this.state;
    let url = window.location.href;

    if (url.includes("test-print")) {
      let split = url.split("/");
      listgenUserID = url[url.length - 2];
      let area = url[url.length - 1];
    }

    let date = new Date();
    let thisYear = date.getFullYear();
    const thisMonth = `${date.getMonth() + 1}`.padStart(2, 0);
    const today = `${date.getDate()}`.padStart(2, 0);

    let isDemo = false;
    // if (
    //   thisArea === "DEMO-SCL-16A" ||
    //   thisArea === "DEMO-SCL-16B" ||
    //   thisArea === "DEMO-SCL-16D" ||
    //   thisArea === "DEMO-SCL-16E" ||
    //   thisArea === "DEMO-SCL-16N"
    // ) {
    //   isDemo = false;
    // }
    let diffVersionToUse;
    let usesDifferentVersion = false;
    try {
      let mailPrint = await axios
        .get(
          `/admin/getMailPrintInfoDetails?listgenUserID=${listgenUserID}&mailerProID=${mailProId}`,
          {
            headers: {
              "content-type": "application/json",
            },
            data: {},
          }
        )
        .then((res) => {
          const singleHOData = res.data.mailerProDTO;
          //const agentData = res.data.listgenUserDTO;
          this.setState({
            singleHOData,
            //agentData,
          });
        })
        .catch((err) => console.log("error retrieving idDetails" + err));

      let navBar = await axios
        .get(`/agent/getNavbarInfo?listgenUserID=${listgenUserID}`, {
          headers: {
            "content-type": "application/json",
          },
          data: {},
        })

        .then((res) => {
          this.setState({
            mlsAreas: res.data,
          });
        })
        .catch((err) => console.log("error retrieving navbarInfo" + err));
      const thisArea = this.state.singleHOData.areaID;
      let currentArea =
        this.state.mlsAreas.filter((area) => area.mlsAreaID === thisArea)[0] ||
        this.state.mlsAreas[0];
      const { mlsAreaID, mlsCityID } = currentArea;

      const { singleHOData } = this.state;
      const { subdivisionName } = singleHOData;
      if (currentArea) {
        let getPmaDetails = await axios
          .get(
            `/agent/getPMADetails?areaCityPeriod=${mlsAreaID}-${mlsCityID}-${thisYear}-${thisMonth}-${today}&subDivision=${
              subdivisionName ? subdivisionName : "-"
            }&listgenUserID=${listgenUserID}&mailerProID=${mailProId}`,

            {
              headers: {
                "content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              data: {},
            }
          )
          .then((res) => {
            const {
              mailerPrintInfoDTO,
              lgTestmonialsDTO,
              missionStatementDTO,
              quadrantInfoList,
            } = res.data;
            const singleHOData = mailerPrintInfoDTO.mailerProDTO;
            let agentData = mailerPrintInfoDTO.listgenUserDTO;
            if (
              listgenUserID === "103" ||
              listgenUserID === "105" ||
              listgenUserID === "100037"
            ) {
              agentData.emailAddress = "sarah.sullivan@compass.com";
              agentData.brokerageName = brokerage;
            }
            this.setState({
              singleHOData,
              agentData,
              currentArea,
              coverPageDetails: res.data.pmaCoverPhotoDTO,
              quarterlyAreaTable: res.data.pmaQuarterlyAreaDTO,
              quadrantDetails: quadrantInfoList,
              quarterlyCityTable: res.data.pmaQuarterlyCityDTO,
              testimonials: lgTestmonialsDTO,
              MQCityDetails: res.data.pmaQuarterlyCityDTO,
              aprilData: {
                pmaQuarterlyAreaDTO: res.data.pmaQuarterlyAreaDTO,
                pmaQuarterlyCityDTO: res.data.pmaQuarterlyCityDTO,
              },
              bubbleBoxes: res.data.marketValueInfoList,
              testimonials: res.data.lgTestmonialsDTO,
              missionStatement: missionStatementDTO,
            });
          })
          .catch((err) =>
            console.log("error retrieving table bubble data" + err)
          );
      }
    } catch (error) {
      console.log("error with bubble compare print apis", error);
    }
  }
  isPrintDataReady = () => {
    const {
      currentArea,
      singleHOData,
      agentData,
      quarterlyAreaTable,
      coverPageDetails,
      quadrantDetails,
    } = this.state;
    return !!(
      currentArea &&
      singleHOData &&
      agentData &&
      quarterlyAreaTable &&
      quarterlyAreaTable.monthsSupplyTable &&
      coverPageDetails &&
      quadrantDetails
    );
  };

  componentDidUpdate() {
    signalPrintReadyIfIdle(this, this.isPrintDataReady());
  }

  componentWillUnmount() {
    stopPrintFontGate(this);
  }

  render() {
    const { propertyData } = this.props;
    const {
      singleHOData,
      agentData,
      mlsAreas,
      marketActivity,
      MQCityDetails,
      currentArea,
      version,
      quarterlyCityTable,
      quarterlyAreaTable,
      localSellingAgents,
      coverPageDetails,
      testimonials,
      agentDesignations,
      agentAdvantages,
      salePriceForCities,
      yearEnd,
      qArea,
      qCity,
      aprilData,
      flipBook,
      missionStatement,
      propertyPhotoDetailsDTO,
      pmaQuarterlyCombinedCityDTO,
      quadrantDetails,
      fontsReady,
    } = this.state;
    if (this.isPrintDataReady() && fontsReady) {
      return (
        <div className="pma-creator">
          <main>
            <section>
              <PmaEditor
                propertyData={propertyData}
                printVersion={true}
                version={version}
                singleHOData={singleHOData}
                agentData={agentData}
                currentArea={currentArea}
                marketActivity={marketActivity}
                MQCityDetails={MQCityDetails}
                mlsAreas={mlsAreas}
                quarterlyAreaTable={quarterlyAreaTable}
                quarterlyCityTable={quarterlyCityTable}
                localSellingAgents={localSellingAgents}
                coverPageDetails={coverPageDetails}
                printTestimonials={testimonials}
                printAgentAdvantages={agentAdvantages}
                printAgentDesignations={agentDesignations}
                salePriceForCities={salePriceForCities}
                yearEnd={yearEnd}
                qArea={qArea}
                qCity={qCity}
                aprilData={aprilData}
                flipBook={flipBook}
                dontShowPma={false}
                missionStatement={missionStatement}
                propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
                pmaQuarterlyCombinedCityDTO={pmaQuarterlyCombinedCityDTO}
                quadrantDetails={quadrantDetails}
              />
            </section>
          </main>
        </div>
      );
    } else {
      return <div>1Loading PMA...</div>;
    }
  }
}

PrintTableQuadrantsPMA.propTypes = {
  params: PropTypes.shape({
    mailproid: PropTypes.string,
    listgenUserID: PropTypes.string,
    brokerage: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      mailproid: PropTypes.string,
      listgenUserID: PropTypes.string,
      brokerage: PropTypes.string,
    }),
  }),
  mailproid: PropTypes.string,
  listgenUserID: PropTypes.string,
  brokerage: PropTypes.string,
};

export default PrintTableQuadrantsPMAWrapper;
